import { render } from "./sysActivityLogList.vue?vue&type=template&id=45642e42"
import script from "./sysActivityLogList.vue?vue&type=script&lang=js"
export * from "./sysActivityLogList.vue?vue&type=script&lang=js"

import "./sysActivityLogList.vue?vue&type=style&index=0&id=45642e42&lang=css"

import exportComponent from "/builds/sptbr/sysa.ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__